import React from 'react';
import AppIcon from '@atlaskit/icon/core/app';
import { token } from '@atlaskit/tokens';
import { ContainerAvatar } from '@atlaskit/navigation-system/side-nav-items/container-avatar';

export const ForgeIcon = ({ url }: { url?: string }): React.JSX.Element =>
	url != null && String(url).trim().length > 0 ? (
		<ContainerAvatar src={url} />
	) : (
		<AppIcon label="" color={token('color.icon')} />
	);
